module.exports = __webpack_public_path__ + "img/Corona.154bc2fb.png";